<template>
  <!-- 多级业务员绑定商品 -->
  <div class="duoJiSalesBangDingGoods">
    <!-- 面包屑导航 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="getGoodsList('')"
          >绑定商品</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleDel('')"
          >批量解绑</el-button
        >
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          @keyup.enter.native="getTableData(1)"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 展示已绑定的商品 -->
    <el-table
      :data="YiBangDingGoodsList"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="article_id"
        label="商品id"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sub_title"
        label="商品名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="drug_factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="drug_spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
        prop="lastmodifytime"
        label="最后更新时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row.article_id)"
            >解绑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 数据选择 -->
    <!--未绑定的商品选择列表-->
    <el-dialog
      title="商品选择"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchUser"
          >
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="search"
            >搜索</el-button
          >
          <el-button type="primary" icon="el-icon-circle-check" @click="submit"
            >确定
          </el-button>
        </template>
      </search-bar>
      <el-table
        stripe
        height="500px"
        width="100%"
        border
        :data="WBangDingGoodsList"
        @selection-change="rowClick"
        row-key="code"
        ref="selectiontt"
        element-loading-text="拼命加载中..."
        v-loading="loading"
      >
        <el-table-column
          width="50"
          type="selection"
          align="center"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column type="index" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{
              (currentchange_vlue - 1) * pagesize_value + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
        prop="article_id"
        label="商品id"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sub_title"
        label="商品名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="drug_factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="drug_spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentchange_vlue"
        :page-size="pagesize_value"
        layout="total,prev, pager, next, jumper,sizes"
        :total="totalnumber"
        prev-text="上一页"
        next-text="下一页"
        :page-sizes="pagesize"
        @size-change="getsizechange"
        @current-change="getcurrentchange"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "duoJiSalesBangDingGoods",
  data() {
    return {
      id: "",
      searchForm: {
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      // 数据选择
      dialogVisible: false,
      loading: false, //加载
      searchUser: "", //弹窗
      YiBangDingGoodsList: [], //已绑定的商品
      WBangDingGoodsList :  [],//未绑定的商品
      //表格下面分页
      userIds: "", //勾选的业务员
      article_id: "",//勾选的商品id
      currentPage: 1,
      totalnumber: 0, //总条数
      pagesize_value: 25, //默认设置页数量
      currentchange_vlue: 1, //总页码
      pagesize: [25, 50, 100, 200],
      userId:"",
    };
  },
  created() {
    // if(!this.userId) {
    //   this.$message.error('缺少必要的业务员ID参数');
    //   return;
    // }
    // this.userId = this.$route.query.userId || "";
    // console.log('this.userId',this.userId);
  },
  mounted() {
    if (this.$route.query.prams) {
      try {
        // 先base64解码再JSON解析
        const decoded = atob(this.$route.query.prams);
        const prams = JSON.parse(decoded);
      //  console.log('接收参数:', prams,this.$route.query.prams);

        // 参数使用
        this.userId = prams.managerId;
        this.getTableData(1, this.userId);

      } catch (e) {
        console.error('参数解析失败:', e);
      }
    } else {
      console.warn('未接收到prams参数');
    }
  },
  methods: {
    updata() {
      if (this.id) {
        this.getTableData();
      }
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**获取已绑定的商品 */
    getTableData(num,userId) {
      this.userId = userId || this.userId; // 优先使用传入的userId
      this.currPage = num == 1 ? 1 : this.currPage;
      let jsonData2 = {
        managerId: this.userId,
        type: "BoundWares",
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      let encodedJson = encodeURIComponent(JSON.stringify(jsonData2));
      this.$request({
        url: `admin/manage/ashx/ReturnJson.ashx?type=ReturnDataSet&json=${encodedJson}&proc=Proc_BindWares`,
        method: "get",
      })
        .then((res) => {
          if(res.flag == 0){
            const rawData = res.table0 || [];
            const tableData = Array.isArray(rawData) 
        ? rawData 
        : (typeof rawData === 'string' ? [] : Object.values(rawData || {}));
            this.YiBangDingGoodsList = tableData
              .map(item => ({
                article_id: item?.article_id || '',  
                sub_title: item?.sub_title || '',
                drug_factory: item?.drug_factory || '',
                drug_spec: item?.drug_spec || ''
            }))
          }
          // console.log('已绑定的商品',this.YiBangDingGoodsList);
          // this.allPage = res.tatal;
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    //弹窗
    getGoodsList() {
      this.dialogVisible = true;
      this.searchUser = "";
      this.article_id = "";
      this.search();
    },
    // 查询未绑定的商品
    search() {
      this.currentchange_vlue = 1;
      // this.getGoodsLists();
      let jsonData3={
        type:"UnboundWares",
        managerId:this.userId,
        pageIndex:this.currPage,
        pageSize:this.pageSize,
      }
      let encodedJson3 = encodeURIComponent(JSON.stringify(jsonData3));
      this.$request ({
        url:`Admin/manage/ashx/ReturnJson.ashx?type=ReturnDataSet&json=${encodedJson3}&proc=Proc_BindWares`,
        method:"get",
      })
      .then((res) =>{
        if(res.flag == 0){
          this.WBangDingGoodsList = res.table0
            .map(item => ({
              article_id: item.article_id,
              sub_title: item.sub_title,
              drug_factory: item.drug_factory,
              drug_spec: item.drug_spec
          }))
        }else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
            this.allPage = 0;
          }
      })
    },
    //页数选择
    getsizechange(val) {
      let _this = this;
      this.currentchange_vlue = 1;
      _this.pagesize_value = val;
      // this.getGoodsLists();
    },
    //选择分页页数
    getcurrentchange(val) {
      let _this = this;
      _this.currentchange_vlue = val;
      // this.getGoodsLists();
    },
    // 选择单条数据
    rowClick(section) {
      this.article_id = "";
      for (var i = 0; i < section.length; i++) {
        this.article_id += section[i].article_id + ",";
      }
      // console.log('选择的商品id',this.article_id);
    },

    /**提交绑定商品*/
    submit() {
      if (this.article_id == "") {
        this.$message({
          message: "请先勾选需要绑定的商品！",
          type: "warning",
        });
        return;
      }
      this.article_id = this.article_id.slice(0, -1);
      let data = {
        // entId: window.localStorage.getItem("entId"),
        type: "Binding",
        managerId: this.userId,
        articleIds: this.article_id,
      };
      let encodedJson4 = encodeURIComponent(JSON.stringify(data));
      this.$request({
        method: "get",
        url: `admin/manage/ashx/ReturnJson.ashx?type=ReturnNumber&json=${encodedJson4}&proc=Proc_BindWares`,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$refs.selectiontt.clearSelection();
            this.getTableData();
            this.dialogVisible = false;
          } else {
            this.$refs.selectiontt.clearSelection();
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**解绑商品 */
    handleDel(id) {
      this.$confirm("确定解绑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let ids = []
          ids = id || this.selectedList.map((item) => item.article_id).join(",");
          // console.log('id', ids);
          const jsonData4 = {
            type: 'Unbound',
            managerId: this.userId,
            articleIds: ids,
          };
          let encodedJson4 = encodeURIComponent(JSON.stringify(jsonData4));
          this.$request({
            url: `admin/manage/ashx/ReturnJson.ashx?type=ReturnNumber&json=${encodedJson4}&proc=Proc_BindWares`,
            method: "get",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "解绑成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    }

  }
};
</script>

<style scoped>
.duoJiSalesBangDingGoods {
  width: 100%;
  height: 100%;
}

.zsekl {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
